export default {
  results: {
    global: null,
    tracks: null
  }
};
